import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { useCallback } from "react";

export const ADD_PRODUCT_TO_STOREFRONT = gql`
  mutation addProductsToStorefront($collectionId: ID!, $productIds: [Int!]) {
    addProductsToStorefront(
      collectionId: $collectionId
      productIds: $productIds
    )
  }
`;

const useAddProductsToStorefront = () => {
  const [addProductsToStorefrontMutation, { loading, data }] = useMutation(
    ADD_PRODUCT_TO_STOREFRONT
  );

  const addProductsToStorefront = useCallback(
    (collectionId: string, productIds: number[]) => {
      return addProductsToStorefrontMutation({
        variables: { collectionId, productIds },
        optimisticResponse: true,
      });
    },
    [addProductsToStorefrontMutation]
  );

  return { addProductsToStorefront, loading, data };
};

export { useAddProductsToStorefront };
